import ColorJSON from "~/data/color.json";

const getColorSet = colorKey => {
    const pageColors = Object.prototype.hasOwnProperty.call(
        ColorJSON.colors,
        colorKey
    )
        ? ColorJSON.colors[colorKey]
        : // Default color
          { primary: ColorJSON.colors.cobalt.primary };

    if (!pageColors.secondary) {
        pageColors.secondary = pageColors.primary;
    }

    // Default text color to light
    if (!Object.prototype.hasOwnProperty.call(pageColors, "text"))
        pageColors["text"] = "light";

    // Default button color to blue
    if (!Object.prototype.hasOwnProperty.call(pageColors, "button"))
        pageColors["button"] = ColorJSON.colors.cobalt.primary;

    pageColors.primaryEscaped = escapeColorForInline(pageColors.primary);
    pageColors.secondaryEscaped = escapeColorForInline(pageColors.secondary);
    pageColors.filigreeEscaped = escapeColorForInline(pageColors.filigree);

    return pageColors;
};

const escapeColorForInline = color => {
    if (!color) return null;

    const escapedColor = color.replace("#", "%23");
    return escapedColor;
};

export { getColorSet, escapeColorForInline };
